import React from 'react';
import { makeStyles } from '@mui/styles';
import { Section, SectionAlternate } from 'components/organisms';
import {
  Contact,
  Gallery,
  Hero,
  Partners,
  Story,
  Team,
  WhoWeAre,
} from './components';

import { team, companies, mapData, gallery } from './data';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  sectionPartners: {
    boxShadow: '0 5px 20px 0 rgba(90, 202, 157, 0.05)',
    '& .section-alternate__content': {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
    },
  },
}));

const About = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Hero id="about"/>
      <Section id="about-story">
        <Story />
      </Section>
    {/*  <Section className={classes.sectionNoPaddingTop}>
        <WhoWeAre />
      </Section> */ }
      {/* <Section id="about-team" className={classes.sectionNoPaddingTop}>
        <Team data={team} />
      </Section> */}
    {/*  <SectionAlternate className={classes.sectionPartners}>
        <Partners data={companies} />
      </SectionAlternate> */}
      <Contact id="about-contact" data={mapData} />
    {/*  <SectionAlternate>
        <Gallery data={gallery} />
      </SectionAlternate>  */}
    </div>
  );
};

export default About;
